import {useMount as _useMount} from 'react-use';

import utils from '@utils';
import {Props} from './types';

export const useMount = (
  props: Props,
  state: {setLoading: React.Dispatch<React.SetStateAction<boolean>>}
) => {
  _useMount(async () => {
    utils.scroll.top();

    await props.actions.users.updateCurrentUsers({
      page: 1,
      sort: props.users.pagination.sort,
      teamId: props.me.teamId,
    });
    props.actions.users.clearTableSort();
    props.actions.users.clearUserDetail();
    props.actions.users.clearSearchWords();

    state.setLoading(false);
  });
};
